export default {
  // 具体套餐
  systemList: [
    {
      key: 1,
      imgSrc: require('@/assets/images/system/basic.png'),
      title: '基础版',
      buttonText: '免费试用',
      text1: '适用于小微企业',
      text2: '提供覆盖多端（PC、APP、客户端、小程序）的电子签名能力，满足企业基础签署的需求，简单易上手',
      text3: '费用：按使用合同份数收费',
      kindList: [
        {
          key: 1,
          icon: require('@/assets/images/system/identity_authentication.png'),
          text: '身份认证',
        },
        {
          key: 2,
          icon: require('@/assets/images/system/foundation_signature.png'),
          text: '基础签署',
        },
        {
          key: 3,
          icon: require('@/assets/images/system/signature_electronics.png'),
          text: '电子签章',
        },
        {
          key: 4,
          icon: require('@/assets/images/system/existing_evidence.png'),
          text: '存证服务',
        },
      ],
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/system/professional.png'),
      title: '专业版',
      buttonText: '在线咨询',
      text1: '适用于成长型企业',
      text2: '更灵活的合同签管产品，支持合同审批流、批量签署、API接口开放、合同管理等进阶功能，签署更高效，系统对接更简单',
      text3: '费用：版本费+使用合同份数计费',
      kindList: [
        {
          key: 1,
          icon: require('@/assets/images/system/batch_signing.png'),
          text: '批量签',
        },
        {
          key: 2,
          icon: require('@/assets/images/system/approve_sign.png'),
          text: '审批流',
        },
        {
          key: 3,
          icon: require('@/assets/images/system/api_interface_open.png'),
          text: 'API接口开放',
        },
        {
          key: 4,
          icon: require('@/assets/images/system/scanning_signature.png'),
          text: '扫码签署',
        },
      ],
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/system/premium.png'),
      title: '高级版',
      buttonText: '在线咨询',
      text1: '适用于中大型/集团型企业',
      text2: '多场景多组织解决方案支持，提供智能化合同管理服务，适配各类大型企业的内部业务系统与流程，提供集团型电子签章建设最佳实践',
      text3: '费用：版本费+使用合同份数计费',
      kindList: [
        {
          key: 1,
          icon: require('@/assets/images/system/multi-organization_space_management.png'),
          text: '多组织多空间管理',
        },
        {
          key: 2,
          icon: require('@/assets/images/system/ocr_paper_contract.png'),
          text: 'OCR纸质合同',
        },
        {
          key: 3,
          icon: require('@/assets/images/system/sso_single_sign.png'),
          text: 'SSO单点登录',
        },
        {
          key: 4,
          icon: require('@/assets/images/system/smart_contract_management.png'),
          text: '智能合同管理',
        },
      ],
    },
  ],
  bannerBottomData: [
    {
      firstLineText: '19年+',
      secondLineText: '服务经验',
    },
    {
      firstLineText: '502万+',
      secondLineText: '企业服务',
    },
    {
      firstLineText: '2.7亿+',
      secondLineText: '个人用户',
    },
    {
      firstLineText: '121亿+',
      secondLineText: '总签署量',
    },
    {
      firstLineText: '24x365小时',
      secondLineText: '管家式服务',
    },
  ],

  // e签宝SaaS产品套餐
  packageTitleData: [
    {
      key: 1,
      title: '即买即用',
      desc: '1小时上线，在线极速签署电子合同',
    },
    {
      key: 2,
      title: '全终端支持',
      desc: 'web、App、短信、钉钉、小程序等',
    },
    {
      key: 3,
      title: '签审管一体',
      desc: '实现电子印章、电子合同签批存管统一管理',
    },
  ],

  // 具体套餐
  electronicCard: [
    {
      key: 1,
      name: '企业套餐A',
      money: '650',
      singleNum: '6.5',
      num: '100',
    },
    {
      key: 2,
      name: '企业套餐B',
      money: '3000',
      singleNum: '6',
      num: '500',
    },
    {
      key: 3,
      name: '企业套餐C',
      money: '5500',
      singleNum: '5.5',
      num: '1000',
    },
  ],

  // 无需邮寄，1分钟完成线上签署
  flowPathOneLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-saas/flow-one.png'),
      text: '实名认证',
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-saas/flow-two.png'),
      text: '申领印章',
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-saas/flow-three.png'),
      text: '线上签署',
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-saas/flow-four.png'),
      text: '发送合同',
    },
  ],
  flowPathTwoLine: [
    {
      key: 1,
      imgSrc: require('@/assets/images/sem-saas/flow-five.png'),
      text: '司法服务',
    },
    {
      key: 2,
      imgSrc: require('@/assets/images/sem-saas/flow-six.png'),
      text: '全流程上链',
    },
    {
      key: 3,
      imgSrc: require('@/assets/images/sem-saas/flow-seven.png'),
      text: '合同管理',
    },
    {
      key: 4,
      imgSrc: require('@/assets/images/sem-saas/flow-eight.png'),
      text: '对方签署',
    },
  ],

  // 行业实践解决方案
  solutions: {
    title: '行业实践解决方案',
    list: [
      {
        videoUrl: require('../../assets/video/human-resource.mp4'),
        imgUrl: require('../../assets/images/solution1.png'),
        link: '免费试用>',
        text: '人力资源',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/logistics.mp4'),
        imgUrl: require('../../assets/images/solution2.png'),
        link: '免费试用>',
        text: '物流',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/bank.mp4'),
        imgUrl: require('../../assets/images/solution3.png'),
        link: '免费试用>',
        text: '银行',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/car-leasing.mp4'),
        imgUrl: require('../../assets/images/solution4.png'),
        link: '免费试用>',
        text: '汽车',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/medical.mp4'),

        // imgUrl: require('../../assets/images/solution5.png'),
        imgUrl: require('../../assets/images/solution8.png'),
        link: '免费试用>',
        text: '医疗',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/construction.mp4'),

        // imgUrl: require('../../assets/images/solution6.png'),
        imgUrl: require('../../assets/images/solution7.png'),
        link: '免费试用>',
        text: '房地产',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/e-commerce.mp4'),

        // imgUrl: require('../../assets/images/solution7.png'),
        imgUrl: require('../../assets/images/solution6.png'),
        link: '免费试用>',
        text: 'B2B电商',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
      {
        videoUrl: require('../../assets/video/online-education.mp4'),

        // imgUrl: require('../../assets/images/solution8.png'),
        imgUrl: require('../../assets/images/solution5.png'),
        link: '免费试用>',
        text: '在线教育',
        url: 'https://www.baidu.com',
        maskShow: true,
        videoShow: false,
      },
    ],
  },

  // 安全可靠的电子合同服务
  safeReliableData: [
    {
      img: require('@/assets/images/sem-saas/serve-one.png'),
      title: '签管一体',
      desc: '实现电子签章、合同管理、存证与审签统一管理，助力企业半程无纸化向全程电子化过渡，使得合同签署流程更加顺畅、便捷。',
    },
    {
      img: require('@/assets/images/sem-saas/serve-two.png'),
      title: '安全可靠',
      desc: '超级计算集群云服务器数量近万台，日均签署量2000万次，平均签署耗时199ms。',
    },
    {
      img: require('@/assets/images/sem-saas/serve-three.png'),
      title: '法律支持',
      desc: '可申请出具多种类型证据报告，包括《e签宝数据存证证明》、《公证书》、《司法鉴定报告》等。',
    },
    {
      img: require('@/assets/images/sem-saas/serve-four.png'),
      title: '陪跑服务',
      desc: '全流程陪跑服务，以客户为中心，向每个企业用户配备专属顾问，为您提供及时响应、高效专业、全面细致的服务。',
    },
  ],

  // saas-ai
  saasAiData: [
    {
      key: 1,
      desc: '·【审批引擎】-内置多级审批引擎，拖曳式灵活配置',
    },
    {
      key: 2,
      desc: '·【合同比对】-AI智能比对能力，0.5秒在线比对OA审批终稿和用印文件',
    },
    {
      key: 3,
      desc: '·【智能台账】-企业合同智能化分类归档，智能获取业务数据自动形成业务台账',
    },
    {
      key: 4,
      desc: '·【信息采集】-合同签署前可灵活采集签署人信息，如身份证、学位证、家庭住址等',
    },
  ],
  orgList: {
    title: '客户案例',
    orgTypeList: ['人力资源', '地产租房', '互联网+', '银行金融', '零售制造', '汽车物流', '教育旅游'],
    imgs: ['humanRes', 'logistics', 'hlw', 'bank', 'lszz', 'qqwl', 'jjly'].map((item) => {
      return require(`@/assets/images/${item}.png`)
    }),
  },
}
